/**
 * The universal onboarding gate signal, same rule as the server's /authorize gate
 * (functions/auth/src/modules/session.ts): ONLY genuinely new accounts are gated — the sign-up
 * flow stamps `onboarding.required = true`; every pre-existing account has no `onboarding` field
 * at all and must never be sent to onboarding (that was the login-loop bug). A new account is
 * "onboarded" once `completedAt` lands on the same map.
 *
 * Kept in its own dependency-free file: connect's auth guard (main bundle) imports it, and it
 * must not drag the onboarding page's catalog code along.
 */
export function needsOnboarding(
  userData: { onboarding?: { required?: boolean; completedAt?: unknown } } | undefined,
): boolean {
  const onboarding = userData?.onboarding;
  if (!onboarding?.required) return false;
  return !onboarding.completedAt;
}

/**
 * The MOBILE app's rule: the server rule above, plus any signed-in account that has no
 * organization (or no user doc yet). On the web such an account is handed to the admin
 * console's /new to create one; inside the shell that hand-off opened admin.crewdle.ai in
 * the system browser — which has no session — and the app fell back to the login screen,
 * looping (Sign in with Apple, TestFlight build 5, 2026-10-08). The in-app onboarding
 * creates the organization, so it is the only place such an account can go on mobile.
 */
export function needsNativeOnboarding(
  userData: { onboarding?: { required?: boolean; completedAt?: unknown }; organizationIds?: unknown } | undefined,
): boolean {
  if (needsOnboarding(userData)) return true;
  const orgIds = userData?.organizationIds;
  return !Array.isArray(orgIds) || orgIds.length === 0;
}
